var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field-tab-content" },
    [
      _c(
        "div",
        { staticClass: "jzliu-bi-fields-wrapper" },
        _vm._l(_vm.fieldsViewWrapper, function (i, idx) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    (i.alias === "drill" && !!i.chooseFields.length) ||
                    i.alias !== "drill",
                  expression:
                    "(i.alias === 'drill' && !!i.chooseFields.length) || i.alias !== 'drill'",
                },
              ],
              key: idx + "h",
              staticClass: "areas-wrapper",
            },
            [
              _c("div", { staticClass: "field-area-wrapper" }, [
                _c("div", { staticClass: "field-area-header" }, [
                  _c("div", { staticClass: "area-name" }, [
                    _c(
                      "i",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: i.isMust,
                            expression: "i.isMust",
                          },
                        ],
                        staticClass: "require-icon",
                      },
                      [_vm._v("*")]
                    ),
                    _vm._v(" "),
                    i.alias === "drill" && _vm.isDrillChart(_vm.selectItem)
                      ? _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            "margin-left": "4px",
                            "vertical-align": "middle",
                            display: "inline-block",
                          },
                          attrs: {
                            width: "13px",
                            src: require("../../assets/img/drilling3.png"),
                            alt: "",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(i.label))]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    i.limitNum
                      ? _c("span", [
                          _vm._v(
                            _vm._s(i.chooseFields.length) +
                              " / " +
                              _vm._s(i.limitNum) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field-area-body" },
                  [
                    !i.chooseFields.length && i.alias !== "filter"
                      ? _c("div", { staticClass: "blank-area-tip" }, [
                          _vm._v("拖动数据字段至此处"),
                        ])
                      : !i.chooseFields.length && i.alias === "filter"
                      ? _c(
                          "div",
                          {
                            staticClass: "blank-area-tip",
                            staticStyle: {
                              position: "absolute",
                              top: "-5px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              "z-index": "1000",
                            },
                            on: { click: _vm.handleAddFilter },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "text", size: "mini" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.filterLength > 0
                                      ? "编辑过滤条件(" + _vm.filterLength + ")"
                                      : "设置过滤条件"
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        class: { "drag-warp": !i.chooseFields.length },
                        attrs: {
                          move: function (e, i) {
                            return _vm.onMove(e, i)
                          },
                          filter: ".blank-area-tip",
                          group: "any",
                          animation: "300",
                        },
                        on: {
                          add: function (e) {
                            return _vm.handleDragUpdate(e, i, idx)
                          },
                        },
                        model: {
                          value: i.chooseFields,
                          callback: function ($$v) {
                            _vm.$set(i, "chooseFields", $$v)
                          },
                          expression: "i.chooseFields",
                        },
                      },
                      _vm._l(
                        _vm.chooseFieldsHandler(i.chooseFields, idx),
                        function (v, vIndex) {
                          return _c(
                            "div",
                            {
                              key:
                                v.id +
                                "_" +
                                idx +
                                "_" +
                                vIndex +
                                "_" +
                                i.queryType,
                              staticClass: "sort-list-item drag-li",
                              attrs: { "data-type": v.defineType },
                            },
                            [
                              _c("div", { staticClass: "field-box-wrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dimension-field-box",
                                    class: ["any", "measure"].includes(
                                      v.defineType
                                    )
                                      ? "measure-border"
                                      : "dimension-border",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bi_dashboard_text_overflow",
                                        staticStyle: {
                                          "max-width": "118px",
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { attrs: { title: v.name } },
                                          [_vm._v(_vm._s(v.name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  v.aggregatorType &&
                                                  i.alias !== "filter",
                                                expression:
                                                  "v.aggregatorType && i.alias !== 'filter'",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.aggregatorMap[
                                                    v.aggregatorType
                                                  ]
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "right-icon" },
                                      [
                                        !(i.alias === "drill" && vIndex === 0)
                                          ? _c("i", {
                                              staticClass: "el-icon-s-tools",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onFieldSetting(v)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleteChooseFields(
                                                i,
                                                vIndex
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: _vm.isDrillFieldsWids(v)
                                                ? "已开启钻取"
                                                : "钻取",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            v.defineType === "dimension" &&
                                            i.alias !== "drill" &&
                                            _vm.isDrillChart(_vm.selectItem)
                                              ? _c("img", {
                                                  class: {
                                                    "jzliu-bi-drill-field-icon":
                                                      _vm.isDrillFieldsWids(v),
                                                  },
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                    "margin-left": "4px",
                                                    "vertical-align": "middle",
                                                  },
                                                  attrs: {
                                                    width: "10px",
                                                    src: !_vm.drillFieldsWids.includes(
                                                      v._wid
                                                    )
                                                      ? require("../../assets/img/drill2.png")
                                                      : require("../../assets/img/drilling3.png"),
                                                    alt: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDrill(
                                                        v,
                                                        i
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !!v.sortType
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: _vm.getSortTooltip(
                                                    v.sortType
                                                  ),
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    "vertical-align": "middle",
                                                    display: "inline-block",
                                                  },
                                                  attrs: {
                                                    width: "13px",
                                                    src: _vm.getSortIcon(
                                                      v.sortType
                                                    ),
                                                    alt: "",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.selectItem.name,
              expression: "!!selectItem.name",
            },
          ],
          staticClass: "update-wrapper",
        },
        [
          _c(
            "div",
            { staticClass: "guid-tip-container" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleUpdateDashboard },
                },
                [_vm._v("更新")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.settingVisible,
            title: "字段设置",
            width: "580px",
            "show-close": false,
            "close-on-click-modal": false,
            "custom-class": "jzliu-bi-field-setting-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.settingVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "jzliu-bi-field-setting-content",
            },
            [
              _c("div", { staticClass: "jzliu-bi-field-item" }, [
                _c("div", { staticClass: "jzliu-bi-field-label" }, [
                  _vm._v("字段原名"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "jzliu-bi-field-original-name bi_dashboard_text_overflow",
                    attrs: { title: _vm.currentField.unitName },
                  },
                  [_vm._v(_vm._s(_vm.currentField.unitName))]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "jzliu-bi-field-item" },
                [
                  _c("div", { staticClass: "jzliu-bi-field-label" }, [
                    _vm._v("显示名称"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "jzliu-bi-field-input",
                    attrs: { placeholder: "请输入内容", size: "small" },
                    model: {
                      value: _vm.fieldDisplayName,
                      callback: function ($$v) {
                        _vm.fieldDisplayName = $$v
                      },
                      expression: "fieldDisplayName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "jzliu-bi-field-item" }, [
                _c("div", { staticClass: "jzliu-bi-field-label" }, [
                  _vm._v("排序"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "jzliu-bi-sort-options" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.fieldSortType,
                          callback: function ($$v) {
                            _vm.fieldSortType = $$v
                          },
                          expression: "fieldSortType",
                        },
                      },
                      _vm._l(_vm.sortOptionList, function (option) {
                        return _c(
                          "el-radio",
                          {
                            key: option.value || "default",
                            attrs: { label: option.value },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.label) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.fieldSortType === "custom"
                  ? _c("div", { staticClass: "jzliu-bi-field-custom-sort" }, [
                      _c(
                        "div",
                        {
                          staticClass: "jzliu-bi-field-custom-sort-warp",
                          on: { click: _vm.openCustomSortDialog },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "jzliu-bi-field-custom-sort-text",
                              class: { "is-placeholder": !_vm.hasCustomSort },
                              attrs: { title: _vm.customSortDisplayTextFull },
                            },
                            [_vm._v(_vm._s(_vm.customSortDisplayText))]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "el-icon-edit" }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.currentField.alias === "measure"
                ? _c("div", { staticClass: "jzliu-bi-field-item" }, [
                    _c("div", { staticClass: "jzliu-bi-field-label" }, [
                      _vm._v("计算方式"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "jzliu-bi-sort-options" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.fieldCalculateType,
                              callback: function ($$v) {
                                _vm.fieldCalculateType = $$v
                              },
                              expression: "fieldCalculateType",
                            },
                          },
                          _vm._l(_vm.listView, function (item) {
                            return _c("el-option", {
                              key: item.type,
                              attrs: { label: item.name, value: item.type },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "jzliu-bi-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.cancelFieldSetting },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.confirmFieldSetting },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.filterSettingDialogVisible,
            title: "过滤条件",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.filterSettingDialogVisible = $event
            },
          },
        },
        [
          _vm.filterSettingDialogVisible
            ? _c("filter-tpl-pro", {
                ref: "filterTplPro",
                attrs: {
                  checkStrictly: true,
                  showAllLevel: false,
                  fieldGroupName: "custom",
                  fields: _vm.fieldsView,
                  negated: _vm.selectItem.filterObj.filterParentNegated,
                  customName: "chart-filter",
                  customProps: { checkStrictly: true },
                },
                on: {
                  "update:negated": function ($event) {
                    return _vm.$set(
                      _vm.selectItem.filterObj,
                      "filterParentNegated",
                      $event
                    )
                  },
                },
                model: {
                  value: _vm.filterList,
                  callback: function ($$v) {
                    _vm.filterList = $$v
                  },
                  expression: "filterList",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "jzliu-bi-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.cancelFilterSetting },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.confirmFilterSetting },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.customSortDialogVisible,
            title: "自定义排序",
            width: "363px",
            "show-close": false,
            "close-on-click-modal": false,
            "custom-class": "jzliu-bi-custom-sort-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.customSortDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "jzliu-bi-custom-sort-content" }, [
            _c(
              "div",
              { staticClass: "jzliu-bi-custom-sort-table" },
              [
                _c(
                  "div",
                  { staticClass: "jzliu-bi-custom-sort-table-header" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "jzliu-bi-custom-sort-table-cell",
                        staticStyle: { flex: "1" },
                      },
                      [_vm._v("维度值")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "jzliu-bi-custom-sort-table-cell",
                        staticStyle: { width: "55px" },
                      },
                      [_vm._v("操作")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "draggable",
                  {
                    attrs: { animation: 200, disabled: false },
                    model: {
                      value: _vm.customSortList,
                      callback: function ($$v) {
                        _vm.customSortList = $$v
                      },
                      expression: "customSortList",
                    },
                  },
                  _vm._l(_vm.customSortList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.value || index,
                        staticClass: "jzliu-bi-custom-sort-table-row",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "jzliu-bi-custom-sort-table-cell",
                            staticStyle: { flex: "1" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "jzliu-bi-custom-sort-value" },
                              [_vm._v(_vm._s(item.value))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "jzliu-bi-custom-sort-table-cell",
                            staticStyle: { width: "55px" },
                          },
                          [
                            _c(
                              "el-dropdown",
                              {
                                attrs: { trigger: "click" },
                                on: {
                                  command: function (cmd) {
                                    return _vm.handleSortCommand(cmd, index)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "jzliu-bi-custom-sort-menu-icon",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 14 14",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M1 2H13M1 7H13M1 12H13",
                                            stroke: "#165DFF",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "moveUp" } },
                                      [_vm._v("上移")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "moveDown" } },
                                      [_vm._v("下移")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "moveTop" } },
                                      [_vm._v("置顶")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "moveBottom" } },
                                      [_vm._v("置底")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "jzliu-bi-custom-sort-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.closeCustomSortDialog },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.confirmCustomSort },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }